import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'

import Bio from '../components/Bio'

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const siteTitle = get(this.props, 'data.site.siteMetadata.title')

    return (
      <section className="section is-medium">
      <div className="container">
        <Helmet title={`${post.frontmatter.title} | ${siteTitle}`} />
        <h1 className="title is-1">{post.frontmatter.title}</h1>
        <p className="subtitle is-3">
          {post.frontmatter.date} 
        </p>
          <div className="tags">
          {post.frontmatter.tags.map((tag)=> (
            <span className="tag" key={tag}>{tag}</span>
          ))}
          </div>
        <div className="content" dangerouslySetInnerHTML={{ __html: post.html }} />
        <hr />
        <Bio />
      </div>
      </section>

    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostByPath($path: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        title
        tags
        date(formatString: "MMMM DD, YYYY")
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/blog-post.js